import React, { createContext } from 'react';
import differenceInDays from 'date-fns/differenceInDays';
import isValid from 'date-fns/isValid';
import enUS from 'date-fns/locale/en-US';
import parseISO from 'date-fns/parseISO';
import { formatMonthOnlyDate, formatNiceDate, formatNiceMonthDate, formatNiceQuarterDate } from '@atlassian/townsquare-date-utils/date-format';
export var DateRangeScale = {
  DAY: 'DAY',
  MONTH: 'MONTH',
  QUARTER: 'QUARTER'
};
var MONTH_THRESHOLD = 31;
var DAY_THRESHOLD = 1;
export var getDateRangeScale = function getDateRangeScale(dateObj) {
  if (dateObj) {
    var dateDiff = differenceInDays(new Date(dateObj.end), new Date(dateObj.start));
    if (dateDiff < DAY_THRESHOLD) {
      return DateRangeScale.DAY;
    }
    if (dateDiff <= MONTH_THRESHOLD) {
      return DateRangeScale.MONTH;
    }
    return DateRangeScale.QUARTER;
  }
  // If date is somehow undefined, we'll show quarters picker by default
  return DateRangeScale.QUARTER;
};
export var renderDateString = function renderDateString(locale, dateString, placeholder, withTimeScale) {
  if (!dateString) {
    return placeholder;
  }
  var endDate = parseISO(dateString.end);
  if (!isValid(endDate)) {
    return placeholder;
  }
  switch (getDateRangeScale(dateString)) {
    case DateRangeScale.DAY:
      return formatNiceDate(endDate, locale);
    case DateRangeScale.QUARTER:
      return formatNiceQuarterDate(endDate, locale);
    default:
    case DateRangeScale.MONTH:
      return withTimeScale ? formatNiceMonthDate(endDate, locale) : formatMonthOnlyDate(endDate, locale);
  }
};
export var getInitialMonthPickerDate = function getInitialMonthPickerDate(props) {
  var parsedDate = props.date ? parseISO(props.date) : new Date();
  return {
    initialYear: parsedDate.getFullYear(),
    year: parsedDate.getFullYear(),
    month: parsedDate.getMonth()
  };
};
var defaultDateLocale = enUS;
var DateLocaleContext = /*#__PURE__*/createContext(defaultDateLocale);
export var useDateLocale = function useDateLocale() {
  return React.useContext(DateLocaleContext);
};